<template>
  <div>
    <van-popup
      v-model="isShow"
      :close-on-popstate="true"
      position="right"
      class="full-width full-height"
    >
      <div class="full-height bg-gray filter-panel">
        <ld-header @click-left="isShow = false">
          {{ $t('C121', '筛选') }}
        </ld-header>
        <div class="orderPanelwrapper">
          <mescroll-vue
            ref="mescroll"
            :down="{use:false}"
          >
            <div class="star-level ">
              <div
                class="check-group"
                v-if="!isYlslh5 && !autoLogin"
              >
                <h3 class="font14">
                  {{ $t('F215', '出差类型') }}
                </h3>
                <van-radio-group v-model="filter.tripType">
                  <van-radio
                    v-for="trip in TripTypeList"
                    :key="trip.value"
                    :name="trip.value"
                  >
                    <span
                      slot="icon"
                      class="check-btn"
                      slot-scope="props"
                      :class="[props.checked ? 'focus bg-main' : 'bg-white']"
                    >{{ trip.name }}</span>
                  </van-radio>
                </van-radio-group>
              </div>

              <div
                class="check-group"
                v-if="!isYlslh5"
              >
                <h3 class="font14">
                  行程类型
                </h3>
                <van-radio-group v-model="filter.productType">
                  <van-radio
                    v-for="trip in ProductTypeList"
                    :key="trip.value"
                    :name="trip.value"
                    v-if="!trip.hidden"
                  >
                    <span
                      slot="icon"
                      class="check-btn"
                      slot-scope="props"
                      :class="[props.checked ? 'focus bg-main' : 'bg-white']"
                    >{{ trip.name }}</span>
                  </van-radio>
                </van-radio-group>
              </div>

              <div class="check-group">
                <h3 class="font14">
                  {{ $t('F217', '日期类型') }}
                </h3>
                <van-radio-group v-model="filter.dateType">
                  <van-radio
                    v-for="trip in DateTypeList"
                    :key="trip.value"
                    :name="trip.value"
                  >
                    <span
                      slot="icon"
                      class="check-btn"
                      slot-scope="props"
                      :class="[props.checked ? 'focus bg-main' : 'bg-white']"
                    >{{ trip.name }}</span>
                  </van-radio>
                </van-radio-group>

                <van-radio-group
                  v-model="dateScope"
                  @change="dateScopeChange"
                >
                  <van-radio name="90">
                    <span
                      slot="icon"
                      class="check-btn"
                      :class="[dateScope==90 ? 'focus bg-main' : 'bg-white']"
                    >近三月</span>
                  </van-radio>

                  <van-radio name="180">
                    <span
                      slot="icon"
                      class="check-btn"
                      :class="[dateScope==180 ? 'focus bg-main' : 'bg-white']"
                    >近半年</span>
                  </van-radio>

                  <van-radio name="365">
                    <span
                      slot="icon"
                      class="check-btn"
                      :class="[dateScope==365? 'focus bg-main' : 'bg-white']"
                    >近一年 </span>
                  </van-radio>
                </van-radio-group>
              </div>
              <!--  -->
              <div class="check-group">
                <van-cell-group>
                  <van-field
                    :readonly="true"
                    :label="$t('F220','日期始')"
                    v-model="filter.dateStart"
                    @click="showDate"
                  />
                  <van-field
                    :readonly="true"
                    :label="$t('F221','日期止')"
                    @click="showDate"
                    v-model="filter.dateEnd"
                  />
                  <van-field
                    :label="$t('F006','出行人')"
                    v-model="filter.psgName"
                    placeholder="请输入出行人"
                    :clearable="true"
                  />

                  <!-- 订单号 -->
                  <van-field
                    :label="$t('F001','订单号')"
                    v-model="filter.orderNo"
                    placeholder="请输入订单号"
                    :clearable="true"
                  />
                </van-cell-group>
              </div>
              <!--  -->
              <div class="check-group">
                <van-row class="filter-panel__reset">
                  <ld-button
                    class="reset"
                    @click.native="reset('close')"
                  >
                    {{ $t('B016', '恢复默认') }}
                  </ld-button>
                  <ld-button
                    class="selection bg-main"
                    @click.native="confirmFilter"
                  >
                    {{ $t('Display', '显示结果') }}
                  </ld-button>
                </van-row>
              </div>
              <!--  -->
            </div>
          </mescroll-vue>
        </div>
        <!--  -->
        <ld-calendar
          ref="date"
          type="range"
          @selected="getDate"
          start-text="起"
          end-text="止"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import {CellGroup, Field, Popup, RadioGroup, Radio} from 'vant'
import ldButton from 'Common/ldButton'
import {formatDate, getDiffDays} from 'Utils/dateUtil'
import MescrollVue from 'mescroll.js/mescroll.vue'
import defaultMixin from '@/business/mixins/default'
import { isGat } from 'Utils/gattools';

const TripTypeList = [
  {
    name: '全部',
    value: ''
  }, {
    name: '因公',
    value: '1',
  }, {
    name: '因私',
    value: '2'
  }
]

const ProductTypeList = [
  {
    name: '全部',
    value: ''
  }, {
    name: '机票',
    value: '10901',
  },
  {
    name: '酒店',
    value: '10903',
  }
  , {
    name: '火车票',
    value: '10904',
  }, {
    name: '用车',
    value: '10906'
  },
  // {
  // 	name: '机场服务',
  // 	value: '10907'
  // },
  {
    name: '代客泊车',
    value: '10908'
  },
  {
    name: '签证',
    value: '10913'
  },
  {
    name: '优先值机',
    value: '10914'
  },
  {
    name: '要客通',
    value: '10915'
  },
  {
    name: '快速安检',
    value: '10916'
  },
  {
    name: '休息室',
    value: '10917'
  }
]

const DateTypeList = [
  {
    name: '预订日期',
    value: '1'
  }, {
    name: '出发/入住日期',
    value: '2'
  }
]

export default {
  name: 'OrderFilter',
  mixins: [defaultMixin],
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Popup.name]: Popup,
    LdCalendar: () => import('Common/ldCalendar/Traveltickets'),
    ldButton,
    MescrollVue
  },
  props: {
    filter: {
      type: Object,
      default: () => {
      }
    },
    visibility: {
      type: Boolean,
      default: false
    },
    findType: {
      type: [String, Number],
      default: 1
    },
    findScope: {
      type: [String, Number],
      default: 1
    },
    autoLogin:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      isShow: false,
      TripTypeList,
      ProductTypeList,
      DateTypeList,
      // minDate: formatDate(new Date(), -90).date,
      // maxDate: formatDate(new Date(), 90).date
      dateScope: '90',
      currentDate: new Date(),
      minDate: new Date(new Date().getFullYear() - 100, 0, 1), // 上世纪的第一天
      // maxDate: new Date(new Date().getFullYear() + 1, 11, 31), // 当年的最后一天
      maxDate: formatDate(new Date(), 90).date, // 当年的最后一天
      countdown: 0,
      timer: null
    }
  },
  created() {
    this.reset()
    if(isGat()){//是关爱通企业隐藏
      this.ProductTypeList.map((item)=>{
        if(item.value !=='10901' && item.value !=='10903'){
          item.hidden=true
        }
      })
    }
  },
  mounted() {
    if (this.filter.dateStart && this.filter.dateEnd) {
      var days = getDiffDays(this.filter.dateStart, this.filter.dateEnd)
      if (days == 90 || days == 180 || days == 365) {
        this.dateScope = days
      }
    }
    const startTime = localStorage.getItem('countdownStartTime')
    const endTime = localStorage.getItem('countdownEndTime')
    if (startTime && endTime) {
      const currentTime = new Date().getTime()
      this.countdown = Math.floor((endTime - currentTime) / 1000) // 计算剩余秒数

      if (this.countdown > 0) {
        const timer = setInterval(() => {
          const currentTime = new Date().getTime()
          this.countdown = Math.floor((endTime - currentTime) / 1000) // 更新剩余秒数
          if (this.countdown <= 0) {
            clearInterval(timer)
            this.reset()
            localStorage.removeItem('countdownStartTime') // 清除存储的起始时间
            localStorage.removeItem('countdownEndTime') // 清除存储的结束时间
          }
        }, 1000)
      } else {
        localStorage.removeItem('countdownStartTime') // 清除存储的起始时间
        localStorage.removeItem('countdownEndTime') // 清除存储的结束时间
      }
    }
  },
  methods: {
    confirmFilter() { // 筛选
      if (this.filter.dateStart > this.filter.dateEnd) {
        this.$toast('结束日期早于开始日期！')
      } else {
        this.$emit('selected')
        this.isShow = false
      }
      // 检查是否存在倒计时
      if (localStorage.getItem('countdownStartTime') && localStorage.getItem('countdownEndTime')) {
        // 如果存在倒计时，则不执行增加时间的操作
        return
      }
      const startTime = new Date().getTime()
      const currentTime = new Date().getTime()
      const tenMinutes = 10 * 60 * 1000 // 10分钟的毫秒数
      const endTime1 = currentTime + tenMinutes // 10分钟后的时间戳
      const endTime = startTime + endTime1 // 1分钟后的时间戳

      this.countdown = Math.floor((endTime - startTime) / 1000) // 计算剩余秒数
      const timer = setInterval(() => {
        const currentTime = new Date().getTime()
        this.countdown = Math.floor((endTime - currentTime) / 1000) // 更新剩余秒数

        if (this.countdown <= 0) {
          clearInterval(timer)
          this.reset()
          localStorage.removeItem('countdownStartTime') // 清除存储的起始时间
          localStorage.removeItem('countdownEndTime') // 清除存储的结束时间
        }
      }, 1000)

      localStorage.setItem('countdownStartTime', startTime) // 存储起始时间
      localStorage.setItem('countdownEndTime', endTime) // 存储结束时间
    },
    //取消筛选
    reset(col) {
      this.filter.dateStart = formatDate(new Date(), -90).date
      this.filter.dateEnd = formatDate(new Date(), 0).date
      this.filter.dateType = '1'
      this.filter.findScope = '1'
      this.filter.findType = '1'
      this.filter.productType = ''
      this.filter.tripType = ''
      this.filter.psgName = ''
      this.filter.orderNo = ''
      this.dateScope = '90'
      if(col=='close'){
        this.isShow=false
        this.$emit('selected')
      }

    },
    showDate() { // 打开日历控件
      this.$refs.date.toggle({
        defaultDate: [this.filter.dateStart, this.filter.dateEnd],
        // minDate: formatDate(new Date(), -1000).date,
        // maxDate: formatDate(new Date(), 90).date,
        // defaultDate: [this.currentDate, this.currentDate],
        minDate: this.minDate,
        maxDate: this.maxDate,
      })
    },
    getDate(date) { // 获取日期回调
      [this.filter.dateStart, this.filter.dateEnd] = date
    },
    dateScopeChange() {
      this.filter.dateStart = formatDate(new Date(), -this.dateScope).date
      this.filter.dateEnd = formatDate(new Date(), 0).date
    }
  },
  watch: {
    visibility(val) {
      this.isShow = val
    },
    isShow(val) {
      this.$emit('update:visibility', val)
    }
  }

}

</script>
<style lang="less">
.star-level {
  padding: 0 8px 50px;

  .check-group {
    margin-top: 12px;

    .van-radio {
      display: inline-block;
    }

    .van-radio__icon {
      height: auto;
    }
  }

  h3 {
    padding-left: 14px;
    margin: 0;
  }

  h5 {
    font-size: 12px;
    padding-left: 14px;
    margin: .10px 0 0 0;
  }

  .check-btn {
    display: inline-block;
    width: 100px;
    margin: 5px;
    font-size: 12px;
    padding: 5px 0;
    color: #7d8285;
    border-radius: 2px;
    text-align: center;
  }

  .check-btn.focus {
    color: @color-text-white;
    box-shadow: 0px 11px 35px 0px rgba(49, 150, 251, 0.04);
  }
}

.orderPanelwrapper {
  height: calc(100vh - 46px);
  overflow: hidden;
}
</style>
